import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface SuperAdminRouteProps {
    children: React.ReactNode;
}

// Guards the Admin Cockpit: only the hard-coded super admin (role === 'superadmin')
// may enter. Unauthenticated users go to login; regular admins go to the dashboard.
const SuperAdminRoute: React.FC<SuperAdminRouteProps> = ({ children }) => {
    const { isAuthenticated, isLoading, user } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="flex h-screen items-center justify-center">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-500 border-t-transparent"></div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (user?.role !== 'superadmin' && user?.role !== 'super_admin') {
        return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
};

export default SuperAdminRoute;
